import React from 'react';
import {DateTime} from 'components/UI/DateTime';
import truncate from 'lodash/truncate';
import {Link} from 'react-router-dom';

class AnnouncementItem extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="announcement-item">
        <div className='announcement-time'>
          <p className='time'><DateTime dateTime={this.props.updatedAt} format="HH:mm" /></p>
          <p className='day'><DateTime dateTime={this.props.updatedAt} format="MM/DD/YYYY" /></p>
        </div>
        <p className='description'>
          {truncate(this.props.content, {length: 100, separator: ' '})}
          <Link to={`/my-business/announcements/${this.props.id}`} className="view-detail">&nbsp;xem chi tiết</Link>
        </p>
      </div>
    );
  }
}

export default AnnouncementItem;



// WEBPACK FOOTER //
// ./components/partials/announcement-block/AnnouncementItem.jsx